export default __webpack_public_path__ + "static/media/Dentist Park- Ma (2).580106c0.png";